import { 
  calculateBomTotals,
  isValidSelectedPart,
  hasValidSelectedPartSupplier,
  hasValidPartSupplierSelections,
  getValidTariffs,
  calculate_estimated_tariff,
} from "../../utils/helpers";

import { 
  DIGIKEY_CODE, 
  MOUSER_CODE, 
  ARROW_CODE, 
  VERICAL_CODE 
} from "../../utils/extracters";


const calculateMarkups = (totals) => {
  const markups = {}
  Object.keys(totals).forEach((board_qty) => {
    let markup = 0.3
    if(totals[board_qty] >= 25000) markup = 0.28
    markups[board_qty] = markup
  })
  return markups;
}

const calculateShipping = (bom_line_items, board_qtys) => {
  const shipping = {}
  const shipping_price = 30
  const found_suppliers = {}
  board_qtys.forEach((board_qty) => {
    found_suppliers[board_qty] = []
  })
  bom_line_items.filter((bli) => bli.user_action == "buy").forEach((bli) => {
    board_qtys.forEach((board_qty) => {
      if(hasValidPartSupplierSelections(bli.selected_part, board_qty)){
        bli.selected_part.ps_selections[board_qty].forEach((ps) => {
          const s_code = ps.supplier.code == VERICAL_CODE ? ARROW_CODE : ps.supplier.code
          if(!found_suppliers[board_qty].includes(s_code)) found_suppliers[board_qty].push(s_code)
        })
      }

      if(hasValidSelectedPartSupplier(bli.selected_part, board_qty)){
        const ps = bli.selected_part.selected_part_supplier[board_qty]
        const s_code = ps.supplier.code == VERICAL_CODE ? ARROW_CODE : ps.supplier.code
        if(!found_suppliers[board_qty].includes(s_code)) found_suppliers[board_qty].push(s_code)
      }
    })
  })
  Object.keys(found_suppliers).forEach((board_qty) => {
    shipping[board_qty] = found_suppliers[board_qty].length * shipping_price
  })

  return shipping;
}

const calculateTariffs = (bom_line_items, board_qtys) => {
  const tariffs = {}
  board_qtys.forEach((board_qty) => {
    tariffs[board_qty] = 0
  })
  bom_line_items.filter((bli) => bli.user_action == "buy").forEach((bli) => {
    board_qtys.forEach((board_qty) => {
      if(hasValidPartSupplierSelections(bli.selected_part, board_qty)){
        bli.selected_part.ps_selections[board_qty].forEach((ps) => {
          const s_code = ps.supplier.code
          const part_tariffs = getValidTariffs(ps.taxes, s_code)
          const extended_price = ps.qty_to_buy * (ps.selected_pricebreak && ps.selected_pricebreak[board_qty] ? ps.selected_pricebreak[board_qty].price : 0)
          const estimated_tariff = calculate_estimated_tariff(part_tariffs, extended_price)
          tariffs[board_qty] += estimated_tariff
        });
      }

      if(hasValidSelectedPartSupplier(bli.selected_part, board_qty)){
        const ps = bli.selected_part.selected_part_supplier[board_qty]
        const qty_to_buy = bli.qty_to_buy && bli.qty_to_buy[board_qty] ? bli.qty_to_buy[board_qty] : 0
        const s_code = ps.supplier.code
        const part_tariffs = getValidTariffs(ps.taxes, s_code)
        const extended_price = qty_to_buy * (ps.selected_pricebreak && ps.selected_pricebreak[board_qty] ? ps.selected_pricebreak[board_qty].price : 0)
        const estimated_tariff = calculate_estimated_tariff(part_tariffs, extended_price)
        tariffs[board_qty] += estimated_tariff
      }
    })
  })
  return tariffs;
}

export const calculateBomPrices = (state) => {
  const base_totals = calculateBomTotals(state.bom_line_items, state.board_qtys)
  const markups = calculateMarkups(base_totals)
  const shipping = calculateShipping(state.bom_line_items, state.board_qtys)
  const tariffs = calculateTariffs(state.bom_line_items, state.board_qtys)

  state.base_totals = base_totals
  state.markups = markups
  state.shipping = shipping
  state.tariffs = tariffs

  state.board_qtys.forEach((board_qty) => {
    state.totals[board_qty] = (base_totals[board_qty] * (1 + markups[board_qty])) + shipping[board_qty] + tariffs[board_qty]
  })
}